import styled from 'styled-components';
import * as S from '../../styles';

interface IsTodayProps {
  isToday?: boolean;
}

export interface ScheduleBlockProps {
  isStart?: boolean;
  isEnd?: boolean;
}

export const Root = styled.div`
  display: flex;
  margin-bottom: 1px;
  padding: 8px 0 0;
`;

export const ColDayHeader = styled(S.BlockBase)`
  padding: 8px;
  height: 64px;
  text-align: center;
`;

export const HeaderDay = styled.div<IsTodayProps>`
  margin-bottom: 4px;
  color: ${({ theme, isToday }) =>
    isToday ? theme.palette.brand400 : theme.palette.grayscale700};
  ${({ theme }) => theme.typography('$caption_02')};
`;

export const HeaderDate = styled.div<IsTodayProps>`
  color: ${({ theme, isToday }) =>
    isToday ? theme.palette.brand400 : theme.palette.grayscale300};
  ${({ theme }) => theme.typography('$body_03')};
`;
